import izitoast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

export const toast = izitoast;

const plugin = {
    install(app, options) {
        let props = {};
        let types = ['info', 'success', 'warning', 'error'];

        types.forEach(type => {
            props[type] = function (message, settings = {}) {
                izitoast[type]({ message, ...options, ...settings });
            }
        });

        app.config.globalProperties.$toast = props;
    }
};

export default plugin;
